import { render, staticRenderFns } from "./addbank.vue?vue&type=template&id=2c6e1745&scoped=true&"
import script from "./addbank.vue?vue&type=script&lang=js&"
export * from "./addbank.vue?vue&type=script&lang=js&"
import style0 from "./addbank.vue?vue&type=style&index=0&id=2c6e1745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e1745",
  null
  
)

export default component.exports